import React, {Component} from 'react';
import {
  Row,
  Card,
  CardBody,
} from 'reactstrap';
import ReactTable from 'react-table';
import {withTranslation} from 'react-i18next';
import {Colxx} from '../components/common/CustomBootstrap';
import {connect} from 'react-redux';
import {reactTableText} from '../constants/configs';
import {createUUID, fixedToWithoutRound, getTokenDecimals} from '../helpers/Utils';
import ToolTip from "../components/ToolTip";
import {isEmpty} from 'lodash';

class AssetsReport extends Component {
  constructor(props) {
    super(props);
    this.renderTokenLogoCell = this.renderTokenLogoCell.bind(this);
  }

  renderTokenLogoCell(props) {
    return (
      <img
        className="avatar-mini"
        src={props.value}
        alt={props.original.name}
      />
    );
  }

  getColumns = t => [
    {
      accessor: 'logoUrl',
      Cell: this.renderTokenLogoCell,
      width: 60,
    },
    {
      Header: t('Name'),
      accessor: 'localeName',
    },
    {
      Header: t('Real Balance'),
      accessor: 'symbol',
      Cell: props => <span>{
        this.props.data && !isEmpty(this.props.data.total_user_balance) ?
          fixedToWithoutRound(
            this.props.data.total_user_balance[props.value],
            getTokenDecimals(props.value)
          ) :
          null
      }</span>
    },
    {
      Header: () => {
        return (
          <ToolTip id={createUUID()} text={t('Include pending withdraws and open orders')}>
            <div className="d-flex flex-row align-items-center">
              <div className="mr-1">{t('Reserved Balance')}</div>
              <i className="icon-Information font-weight-semibold" style={{fontSize: 18}}/>
            </div>
          </ToolTip>
        );
      },
      accessor: 'symbol',
      Cell: props => <span>{
        this.props.data && !isEmpty(this.props.data.reserved_balance) ?
          fixedToWithoutRound(
            this.props.data.reserved_balance[props.value],
            getTokenDecimals(props.value)
          ) :
          null
      }</span>
    },
    {
      Header: t('Entrance to gift bank'),
      accessor: 'symbol',
      Cell: props => <span>{
        this.props.data && this.props.data.gift && !isEmpty(this.props.data.gift) && !isEmpty(this.props.data.gift.reserved) ?
          fixedToWithoutRound(
            this.props.data.gift.reserved[props.value],
            getTokenDecimals(props.value)
          ) :
          null
      }</span>
    },
    {
      Header: () => {
        return (
          <ToolTip id={createUUID()} text={t('Include activated and refunded gifts')}>
            <div className="d-flex flex-row align-items-center">
              <div className="mr-1">{t('Output from gift bank')}</div>
              <i className="icon-Information font-weight-semibold" style={{fontSize: 18}}/>
            </div>
          </ToolTip>
        );
      },
      accessor: 'symbol',
      Cell: props => <span>{
        this.props.data && this.props.data.gift && !isEmpty(this.props.data.gift) && !isEmpty(this.props.data.gift.returned) ?
          fixedToWithoutRound(
            this.props.data.gift.returned[props.value],
            getTokenDecimals(props.value)
          ) :
          null
      }</span>
    },
    // {
    //   Header: t('Bank Balance'),
    //   accessor: 'symbol',
    //   Cell: props => <span>{
    //     this.props.data && !isEmpty(this.props.data.bank_balance) ?
    //       fixedToWithoutRound(
    //         this.props.data.bank_balance[props.value],
    //         getTokenDecimals(props.value)
    //       ) :
    //       null
    //   }</span>
    // },
    {
      Header: t('Physical Balance'),
      accessor: 'symbol',
      Cell: props => <span>{
        this.props.data && !isEmpty(this.props.data.physical_balance) ?
          fixedToWithoutRound(
            this.props.data.physical_balance[props.value],
            getTokenDecimals(props.value)
          ) :
          null
      }</span>
    },
    {
      Header: t('Creditor / (Debtor)'),
      accessor: 'symbol',
      Cell: props => {
        const physicalBalance = this.props.data && !isEmpty(this.props.data.physical_balance) ?
          this.props.data.physical_balance[props.value] : 0;
        const totalBalance = this.props.data && !isEmpty(this.props.data.total_user_balance) ?
          this.props.data.total_user_balance[props.value] : 0;
        return (
          <span className={totalBalance - physicalBalance < 0 ? 'text-danger' : ''}>
            {this.props.data ?
              `${totalBalance - physicalBalance < 0 ? '(' : ''}
              ${fixedToWithoutRound(
                Math.abs(totalBalance - physicalBalance),
                getTokenDecimals(props.value)
              )}
              ${totalBalance - physicalBalance < 0 ? ')' : ''}` :
              null}
          </span>
        );
      }
    },
  ];

  render() {
    const {t, data, tokens} = this.props;
    const newTokens = [...tokens];
    return (
      <Row>
        <Colxx xxs="12" className="mb-4">
          <Card className="h-100">
            <CardBody>
              <ReactTable
                manual
                className="-highlight"
                data={newTokens}
                loading={!data}
                sortable={false}
                resizable={true}
                showPagination={false}
                columns={this.getColumns(t)}
                defaultPageSize={6}
                style={{
                  width: '100%'
                }}
                {...reactTableText}
              />
            </CardBody>
          </Card>
        </Colxx>
      </Row>
    );
  }
}

const mapStateToProps = state => ({
  tokens: state.general.tokens,
});

export default connect(mapStateToProps)(withTranslation()(AssetsReport));
